var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-left-right-resize",
    {
      ref: "cargoLeftRightResize",
      staticStyle: { "min-height": "100%" },
      attrs: {
        "left-style": {
          flex: "none",
          "max-width": "700px",
          width: _vm.cargoLfResizeCacheValue.leftW
        },
        "right-style": {
          overflow: "hidden",
          width: _vm.cargoLfResizeCacheValue.rightW
        }
      },
      on: {
        onSize: function($event) {
          _vm.cargoLfResizeCacheValue = $event
        }
      }
    },
    [
      _c("template", { slot: "left" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              "min-width": "190px",
              height: "100%",
              cursor: "pointer",
              padding: "5px",
              "background-color": "#F5F7FA"
            }
          },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                "show-side-bar": false,
                "config-module": "20220812",
                "grid-options": _vm.officeDeptTree.gridOptions,
                "column-defs": _vm.officeDeptTree.columnDefs,
                "row-data": _vm.officeDeptTree.rowData
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        )
      ]),
      _c("template", { slot: "right" }, [
        _c(
          "div",
          {
            staticStyle: {
              "overflow-y": "scroll",
              height: "100%",
              width: "100%"
            }
          },
          [
            _vm.currentComponent === "officeTab"
              ? _c("office-tab", {
                  ref: "officeTab",
                  attrs: {
                    "dept-list": _vm.deptList,
                    "image-type-list": _vm.imageTypeList,
                    "tree-node": _vm.currentState.treeNode,
                    "office-count": _vm.officeCount
                  },
                  on: {
                    refreshTree: _vm.toRefreshTree,
                    editData: _vm.editHandler,
                    addDept: _vm.officeToAddDept
                  }
                })
              : _vm.currentComponent === "deptTab"
              ? _c("dept-tab", {
                  ref: "deptTab",
                  attrs: {
                    "source-type": _vm.currentState.dept.sourceType,
                    "tree-node": _vm.currentState.treeNode
                  },
                  on: {
                    editData: _vm.editHandler,
                    refreshTree: _vm.toRefreshTree,
                    addRole: _vm.deptToAddRole,
                    cancel: _vm.toBackOffice4Dept
                  }
                })
              : _vm.currentComponent === "roleTab"
              ? _c("role-tab", {
                  ref: "roleTab",
                  attrs: {
                    "source-type": _vm.currentState.role.sourceType,
                    "tree-node": _vm.currentState.treeNode
                  },
                  on: {
                    editData: _vm.editHandler,
                    refreshTree: _vm.toRefreshTree,
                    cancel: _vm.toBackDept4Role
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }